const SEASON_START_MONTH = 2 // March is month index 2

/**
 * Returns the year label for the Christmas season (March to March).
 */
export const getChristmasSeasonYear = (referenceDate = new Date()): number => {
  const year = referenceDate.getFullYear()
  const month = referenceDate.getMonth()

  return month < SEASON_START_MONTH ? year - 1 : year
}

export const CHRISTMAS_SEASON_YEAR = getChristmasSeasonYear()
